var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.73173L11.5527 1.32832C11.1891 0.96323 10.6963 0.756348 10.1833 0.756348H1.93891C0.868471 0.760404 0 1.63255 0 2.70753V19.5826C0 20.6576 0.868471 21.5298 1.93891 21.5298H13.5724C14.6428 21.5298 15.5113 20.6576 15.5113 19.5826V6.11095C15.5113 5.59577 15.3053 5.09682 14.9417 4.73173ZM10.3409 2.86573L13.4148 5.95274H10.3409V2.86573ZM13.5724 19.5826H1.93891V2.70753H8.40195V6.92631C8.40195 7.46582 8.83416 7.89987 9.3714 7.89987H13.5724V19.5826Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60081 13.3441L6.28606 13.911V14.8569L3.56254 13.7477V12.9282L6.28606 11.8191V12.7619L4.60081 13.3441Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28427 15.6055H6.54793L8.07914 10.7346H8.81855L7.28427 15.6055Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8735 13.3349L9.19751 12.7649V11.8222L11.9056 12.9313V13.7508L9.19751 14.8599V13.9172L10.8735 13.3349Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.76123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.7efd2aeaf0bab9f853a2346980a6779a.svg";
export { ForwardRef as ReactComponent };